import React, { useEffect, useRef } from 'react';
import { RubigramStore } from '../RubigramStore';
import { rotatePuzzleVisual } from '../rubigramUtils';
import ControlSubgrid from './ControlSubgrid';
import { IconButton } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import SolvedGrid from './SolvedGrid';
import { useSolvedOnLoad } from '../../shared/utils';

const ControlGrid = () => {
  const { degreesRotated: degreesPuzzleRotated, solved, revealed }
    = RubigramStore.useState();

  const wasSolvedOnLoad = useSolvedOnLoad(solved);

  const puzzleIsRotated90Deg = degreesPuzzleRotated % 180 !== 0;
  const flipperStyles: React.CSSProperties = {
    transform: `rotateZ(${degreesPuzzleRotated}deg)`
      // always rotate on vertical axis for solved animation
      + (solved ? (puzzleIsRotated90Deg ? ` rotateX(720deg)`: ` rotateY(720deg)`): ''),
    transitionDelay: solved ? '0.4s' : undefined,
    transitionDuration: solved ? '1.0s' : undefined,
  };

  const degreesToRotateCenterButton = (-1) * (degreesPuzzleRotated + 50);

  const centerButtonStyles: React.CSSProperties = {
    transform: `rotate(${degreesToRotateCenterButton}deg) scaleX(-1)`,
  };

  if (revealed || wasSolvedOnLoad) return <SolvedGrid/>;

  return (
    <div className="controlGrid grid" onContextMenu={(e) => { e.preventDefault(); }}>
      <div className="controlGridFlipper" style={flipperStyles}>

        <div className="controlGridContents">
          <ControlSubgrid subgridId={0}/>

          <ControlSubgrid subgridId={1}/>

          <ControlSubgrid subgridId={3}/>

          <ControlSubgrid subgridId={2}/>

          <IconButton disableRipple className="rotateGridClockwiseButton" title="Rotate Clockwise/Counterclockwise"
            onClick={() => {
              if (solved || revealed) return;
              rotatePuzzleVisual(true);
            }}
            onContextMenu={(e) => {
              e.preventDefault();
              if (solved || revealed) return;
              rotatePuzzleVisual(false);
            }}
          >
            <ReplayIcon style={centerButtonStyles}/>
          </IconButton>
        </div>

      </div>
    </div>
  );
};

export default ControlGrid;